import React from "react";
import PrivateRoute from "PrivateRoutes";
import { REPORT } from "./components";

const routes = () => (
	<PrivateRoute exact path="/reporting/auto-dispose-summary" component={REPORT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/AgentAutoDisposeSummary/routes.js